import { EvtSelect } from "components/select";
import { getDirectusField, getItemsFromCollection } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

const SelectName = ({
  collection,
  className,
  value,
  onChange,
  placeholder,
  fetchItems = false, // New prop to switch between field choices and collection items
  filter = {}, // Filter to apply when fetching items
  ...props
}) => {
  const { data, isLoading, isError } = useFetch({
    queryKey: [collection, fetchItems ? "items" : "name", filter],
    queryFn: async () => {
      if (fetchItems) {
        // Fetch actual items from the collection
        const response = await getItemsFromCollection(collection, {
          fields: ["id", "name"],
          limit: -1, // Get all items
          filter,
        });
        return response.map((item) => ({
          name: item.name,
          id: item.id,
        }));
      } else {
        // Fetch field choices from field metadata
        const response = await getDirectusField(collection, "name");
        const data = response.meta.options.choices.map((name) => {
          return { name: name.text, id: name.value };
        });
        return data;
      }
    },
    enabled: !!collection,
  });

  return (
    <EvtSelect
      data={data}
      isLoading={isLoading}
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type="filter"
      {...props}
    />
  );
};

export default SelectName;
